<template>
    <div>
        <bread-crumb :items="breadcrumbPath" />
        <v-divider />
        <div
            class="row"
            v-cloak
        >
            <div class="col main-content">
                <div
                    class="offset-xs-4 col-xs-4"
                    v-if="loading"
                >
                    <cube-shadow
                        background="#295e89"
                        shadow="#cc0000"
                    />
                </div>
                <div
                    id="apiError"
                    v-else-if="fatalFetchError.state"
                >
                    <div class="text-xs-center">
                        <h3>API Error</h3>
                        <i claspes="fas fa-exclamation" />
                        <p>Failed to execute {{ fatalFetchError.value }}</p>
                    </div>
                </div>
                <div v-else>
                    <v-container
                        grid-list-md
                        mt-2
                        style="padding: 0"
                        text-xs-center
                    >
                        <v-toolbar
                            class="elevation-1"
                            dense
                            style="max-width: 500px;"
                        >
                            <v-text-field
                                :value="personnelFilter"
                                @click:append="clearFilterPersonnelList"
                                @input="filterPersonnelList"
                                append-icon="close"
                                hide-details
                                id="searchByName"
                                placeholder="Search by name"
                            />
                            <personnel-table-filter-dialog
                                :employment-type-list="employmentTypeList"
                                :job-list="jobList"
                            />
                        </v-toolbar>
                    </v-container>
                    <personnel-table />
                    <h3
                        class="text-center"
                        v-if="person && person.length > 0"
                    >{{ person[0].name }}</h3>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb.vue'; // @ is an alias to /src
    import PersonnelTable from '@/views/ManagePersonnel/components/PersonnelTable.vue';
    import {mapGetters} from "vuex";
    import {FETCH_EMPLOYMENT_TYPES,} from "@/store/employment_type/actions";
    import {FETCH_JOB_LIST} from "@/store/job/actions"
    import {CLEAR_FILTER_PERSONNEL, FILTER_PERSONNEL, RESET_PERSON} from "@/store/person/mutations";
    import {FETCH_PERSONNEL_COUNTRY_LIST} from "@/store/personnel_country/actions.js";
    import PersonnelTableFilterDialog from "./components/PersonnelTableFilterDialog";

    export default {
        name: "ManagePersonnel",
       components: {
            PersonnelTableFilterDialog,
            PersonnelTable,
            BreadCrumb,
        },
        props: {},
        data: function () {
            return {
                breadcrumbPath: [
                    {
                        text: 'Manage Personnel',
                        to: '/manage-personnel',
                    }],
                loading: false,
                selectedPersonId: '',
                personId: '',
                chosenPerson: {},
            };
        },
        computed:
        {
            ...mapGetters(
            ["jobList", "departmentList", "person", "personnelFilter", "fatalFetchError", "teamList", "employmentTypeList"]
            )
        },
        mounted() {
            if (
            this.$route.params !== undefined
            && this.$route.params.personId !== undefined) {
                this.personId = this.$route.params.personId;
            }

            this.resetPerson();
            this.getPersonnelCountryList();
            this.fetchJobs();
        },
        methods: {
            resetPerson() {
                this.$store.commit(RESET_PERSON);
            },
            getPersonnelCountryList() {
                this.$store.dispatch(FETCH_PERSONNEL_COUNTRY_LIST);
            },
            fetchJobs() {
                this.$store.dispatch(FETCH_JOB_LIST);
            },
            clearFilterPersonnelList() {
                this.$store.commit(CLEAR_FILTER_PERSONNEL);
            },
            filterPersonnelList(value) {
                this.$store.commit(FILTER_PERSONNEL, value);
            },
            fetchEmploymentTypes() {
                this.$store.dispatch(FETCH_EMPLOYMENT_TYPES);
            }
        }
    }
</script>

<style scoped>
    /*// Small devices (landscape phones, 576px and up)*/
    @media (max-width: 576px) {
        .row {
            max-width: 100%;
            margin: 0 !important;
        }
    }

    /*// Small devices (landscape phones, 576px and up)*/
    @media (min-width: 576px) {
        .container {
            padding: 0;
            margin: 0;
        }

        body {
            padding: 0;
        }

        #mainDetails {
            padding: 0;
        }

    }

    /*// Medium devices (tablets, 768px and up)*/
    @media (min-width: 768px) {
    }

    /*// Large devices (desktops, 992px and up)*/
    @media (min-width: 992px) {
    }

    /*// Extra large devices (large desktops, 1200px and up)*/
    @media (min-width: 1200px) {
    }

    body {
        font-family: 'Open Sans', sans-serif !important;
        /*background: #fafafa;*/
    }

    #apiError {
        text-align: center;
    }
</style>
